import { SET_TARGET_KEYS, SET_TARGET_KEYS_FREE_CLASS } from "../constants";

const initialState = [];

export const peakListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TARGET_KEYS: {
      state = [...payload];
      return state;
    }
    case SET_TARGET_KEYS_FREE_CLASS: {
      state = [...payload];
      return state;
    }
    default: {
      return state;
    }
  }
};
